import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

import { environment } from 'environments/environment';
import { of, ReplaySubject } from 'rxjs';
import { concatMap, filter } from 'rxjs/operators';
import { SpAuthMfaService } from './auth.mfa.service';

@Injectable({ providedIn: 'root' })
export class SpAuthService {
  accessToken = '';
  private accessTokenSubject = new ReplaySubject<string>(1);
  /*** Observable used to connect to observable cache. */
  accessTokenSilently$ = this.accessTokenSubject.asObservable();
  error$ = this.auth0.error$;

  authIds$ = this.auth0.idTokenClaims$.pipe(
    filter(claims => !!claims),
    concatMap(claims => {
      return of({
        bcl: `${claims['http://www.surepayroll.com/bcl']}`,
        secLoginId: `${claims['http://www.surepayroll.com/sec_login']}`,
        programCode: `${claims['http://www.surepayroll.com/program_code']}`,
        partnerCode: `${claims['http://www.surepayroll.com/partner_code']}`,
      });
    })
  );

  isAuthenticated$ = this.auth0.isAuthenticated$;

  constructor(private auth0: AuthService, private spAuthmfa: SpAuthMfaService) {}

  loginWithRedirect = () => {
    this.RetrieveAccessToken();
  };

  logout = () => this.auth0.logout();

  public get isSigninMfaRedirectCallback() {
    const search = window.location.search;
    const path = window.location.pathname || '';
    return (search.includes('code=') || search.includes('error=')) && search.includes('state=');
  }

  RetrieveMfaAccessToken() {
    this.spAuthmfa.RetrieveMfaAccessToken(this.auth0);
  }

  RetrieveAccessToken() {
    this.auth0
      .getAccessTokenSilently({
        audience: environment.auth.audience,
        scope: 'openid profile email',
        detailedResponse: true,
      })
      .subscribe({
        next: mfaAccessTokenSilently => {
          console.log('Success in RetriveAccessToken authService...');
          const obj = mfaAccessTokenSilently as any; // what comes back from getAccessTokenSilently() is not really a string. blows up when trying to do a .split()

          let token = '';
          if (obj != 'undefined' && 'access_token' in obj) {
            token = obj['access_token'];
            this.accessToken = token;
          } else {
            token = obj as string;
            this.accessToken = token;
          }

          this.accessTokenSubject.next(token);
        },
        error: err => {
          console.log('Error in RetriveAccessToken authService', err);
          this.auth0.loginWithRedirect();
        },
      });
  }
}
